import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { resellerFaq } from "../../data/reseller";

export const ResellerFaq = () => (
  <section id="faq" className="max-w-[900px] mx-auto px-5 md:px-6 py-16 scroll-mt-20">
    <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight">Perguntas frequentes</h2>
    <Accordion type="single" collapsible className="mt-8 rounded-2xl border border-white/10 bg-surface/50 px-5 md:px-7">
      {resellerFaq.map((f, i) => (
        <AccordionItem key={f.q} value={`faq-${i + 1}`} data-testid={`faq-item-${i + 1}`} className="border-white/10 last:border-b-0">
          <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="text-left text-base font-semibold hover:no-underline hover:text-brand-2">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-silver/80 leading-relaxed">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
